import { Button } from '@nextiva/next-ui';
import { styled } from '@nextiva/next-ui-components';

/**
 * Base styles for the tab buttons.
 * These styles are applied to both payment and summary tab buttons.
 */
const baseStyledTabButtonStyles = {
  minHeight: '2.5rem',
  visibility: 'hidden',
  width: '8.5rem',

  '.payment-method__card:hover &': {
    visibility: 'visible',
  },
};

/**
 * A styled button component for the default payment method.
 * Applies special background and text color when the button has the 'nx-button--default' class.
 */
export const StyledDefaultButton = styled(Button)(({ theme }) => ({
  ...baseStyledTabButtonStyles,
  '&.nx-button--default': {
    backgroundColor: '#F0F6FF',
    color: theme.palette.primary.main,
  },
}));

/**
 * A styled button component for the delete action.
 * Inherits base tab button styles and sets a fixed width.
 */
export const StyledDeleteButton = styled(Button)({
  ...baseStyledTabButtonStyles,
  width: '4.5rem',
});

/**
 * A styled container div for aligning and spacing child elements horizontally.
 */
export const StyledContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: '0.5rem',
});
